/**
 * «Скачать PDF»: тот же адрес счёта с download=1, бэкенд отвечает
 * Content-Disposition: attachment. Атрибут download у ссылки на другой
 * домен браузер игнорирует, поэтому решает сервер.
 */
export function invoiceDownloadUrl(invoiceUrl: string): string {
  try {
    const url = new URL(invoiceUrl);
    url.searchParams.set("download", "1");
    return url.toString();
  } catch {
    const separator = invoiceUrl.includes("?") ? "&" : "?";
    return `${invoiceUrl}${separator}download=1`;
  }
}
